module.exports = __webpack_public_path__ + "img/youtube-brands.867ba8fb.svg";